import { inject } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { OnboardingCreateStoryConstants as ui } from '../../Config/UIConstants';
import { CommonActionButton } from '../../SharedComponents/CommonActionButton';
import { CommonTabbedContainer, Tab } from '../../SharedComponents/CommonTabbedContainer';
import { FullScreenModalContainer } from '../../SharedComponents/FullScreenModalContainer';
import { Routes } from '../../_controllers/RouteController';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { PadLock } from '../../images/images';
import { colors } from '../../styles/colors';
import { largeShadow } from '../../styles/styleObjects';

interface IState {
    activeTab: Tab;
    shouldCheckInputs: boolean;
}

interface IProps {
    store: ApplicationStore;
}

@inject('store')
export class OnboardingShareStory extends React.Component<RouteComponentProps<any> & IProps> {
    //TODO: We should set a warning if you try to navigate away from this page, the signup information will be lost.

    public state: IState = {
        activeTab: Tab.LEFT,
        shouldCheckInputs: false,
    };

    private onPressNext = async (): Promise<void> => {
        this.setState({ shouldCheckInputs: true }, async () => {
            const storyIsPrivate = this.state.activeTab === Tab.LEFT;

            if (storyIsPrivate) {
                await this.props.store.onboardingStore.createStoryPrivately();
                await this.props.store.onboardingStore.addAllPhotosToStory();
            }

            this.props.history.push(storyIsPrivate ? Routes.ONBOARDING_FINISHED : Routes.ONBOARDING_CREATE_FAMILY);
        });
    }

    public render() {
        return (
            <FullScreenModalContainer
                justifyContent="space-between"
                alignItems="center"
                {...this.props}
                onPressExit={() => this.props.history.push(Routes.ALBUMS)}
            >
                <div style={styles.contentContainer}>
                    <p style={styles.midSubHeader}>{ui.STEP_FOUR}</p>
                    <p style={styles.bottomSubHeader}>{ui.BOTTOM_SUB_HEADER}</p>
                    {this.state.activeTab === Tab.RIGHT && <p style={styles.shareWarning}>{ui.SHARE_WARNING}</p>}

                    <CommonTabbedContainer
                        leftHeader={ui.KEEP_PRIVATE_HEADER}
                        rightHeader={ui.SHARE_HEADER}
                        activeTab={this.state.activeTab}
                        onPressTab={(tab: Tab) => this.setState({ activeTab: tab })}
                        leftComponent={() => (
                            <div style={styles.leftTabContainer}>
                                <img src={PadLock} style={styles.lockImage} />
                                <p style={styles.lockText}>{ui.NO_SHARE}</p>
                            </div>
                        )}
                        rightComponent={() => (
                            <div style={styles.rightTabContainer}>
                                <p style={styles.rightTabText}>{ui.SHARE_INSTRUCTIONS}</p>
                            </div>
                        )}
                    />
                </div>
                <div style={styles.bottomContainer}>
                    <CommonActionButton
                        buttonContent={this.state.activeTab === Tab.LEFT ? ui.NO_FAMILY_NEXT : ui.FAMILY_NEXT}
                        containerStyle={styles.buttonContainer}
                        fontStyle={styles.buttonText}
                        onClick={this.onPressNext}
                    />
                </div>
            </FullScreenModalContainer>
        );
    }
}

const styles = {
    storyNameWarningText: {
        marginBottom: -10,
        marginTop: 5,
    },
    rightTabText: {
        color: 'black',
        paddingTop: 3,
        marginLeft: 8,
        textAlign: 'center',
        width: '100%',
    } as React.CSSProperties,
    rightTabContainer: {
        width: '100%',
        backgroundColor: 'white',
        height: 50,
        display: 'flex',
        alignItems: 'center',
    } as React.CSSProperties,
    lockText: {
        color: 'black',
        paddingTop: 3,
        marginLeft: 8,
    },
    lockImage: {
        marginLeft: 15,
        height: 15,
        width: 15,
        objectFit: 'contain',
    } as React.CSSProperties,
    leftTabContainer: {
        width: '100%',
        backgroundColor: 'white',
        height: 50,
        display: 'flex',
        alignItems: 'center',
    } as React.CSSProperties,
    bottomSubHeader: {
        width: '200%',
        marginLeft: '-50%',
        textAlign: 'center',
        fontSize: 18,
        opacity: 0.8,
        marginTop: 10,
        marginBottom: 40,
    } as React.CSSProperties,
    shareWarning: {
        width: '100%',
        textAlign: 'center',
        fontSize: 18,
        opacity: 0.8,
        marginTop: -10,
        marginBottom: 10,
    } as React.CSSProperties,
    midSubHeader: {
        fontSize: 22,
        marginTop: 30,
        color: 'black',
        fontWeight: 900,
        textAlign: 'center',
    } as React.CSSProperties,
    topSubHeader: {
        width: '100%',
        textAlign: 'center',
        fontSize: 18,
        opacity: 0.8,
        marginTop: 50,
    } as React.CSSProperties,
    inputContainer: {
        width: '100%',
        height: 85,
        marginBottom: 15,
        backgroundColor: 'white',
        boxShadow: largeShadow,
        marginTop: 20,
    },
    headerText: {
        fontSize: 25,
        color: colors.DARK_TEXT,
        marginTop: 50,
    },
    contentContainer: {
        display: 'flex',
        width: 450,
        height: '50%',
        flexDirection: 'column',
        justifyContent: 'center',
        flex: 1,
    } as React.CSSProperties,
    bottomContainer: {
        height: 150,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
    } as React.CSSProperties,
    buttonText: {
        fontSize: 14,
        fontWeight: 200,
        letterSpacing: 1,
    } as React.CSSProperties,
    buttonContainer: {
        height: 48,
        width: 180,
    },
};



// WEBPACK FOOTER //
// ./src/Pages/OnboardingPages/OnboardingShareStory.tsx